import React from "react";
import { useFeatureFlagManager } from "../FeatureFlag.context";
import { Box, Switch } from "@shape-ds/components";
import { FeatureFlagsAbTests } from "./FeatureFlagsAbTests";

interface FeatureFlagsWrapperProps {
  searchTerm: string;
  type: "AB_TEST" | "FEATURE_FLAG";
}

const FeatureFlagsWrapper: React.FC<FeatureFlagsWrapperProps> = ({
  searchTerm,
  type,
}) => {
  const { featureFlags, ABTestFlags, setFeatureFlag } = useFeatureFlagManager();

  const flagsList =
    type === "FEATURE_FLAG"
      ? Object.keys(featureFlags)
      : Object.keys(ABTestFlags);

  const filteredFlags =
    searchTerm.length > 0
      ? flagsList.filter((flag) =>
          flag.toLowerCase().includes(searchTerm.toLowerCase())
        )
      : flagsList;

  return (
    <Box className="ff-wrapper">
      <h3>{type.replace(/_/g, " ")}</h3>
      {filteredFlags.map((flag) => {
        if (type === "FEATURE_FLAG") {
          return (
            <Switch
              key={flag}
              label={flag}
              checked={featureFlags[flag]}
              onChange={(_, checked) => {
                setFeatureFlag(flag, checked);
              }}
            />
          );
        }
        return (
          <FeatureFlagsAbTests
            flagKey={flag}
            enabled={ABTestFlags[flag]?.enabled}
            variant={ABTestFlags[flag]?.variant}
          />
        );
      })}
    </Box>
  );
};

export default FeatureFlagsWrapper;
